<script setup lang="ts">

</script>

<template>
  <div class="min-h-screen p-6">
    <h1 class="text-2xl font-bold">Bank Detail View</h1>
  </div>
</template>

<style scoped>

</style>